<template>
  <div class="columns has-background-primary-dark call-to-action py-6">
    <div class="column">
      <div
        class="title has-text-light is-size-4 mb-6 is-size-3-desktop hyphenate"
      >
        {{ title }}
      </div>
      <div class="subtitle has-text-light pb-6 hyphenate">{{ subtitle }}</div>
      <RouterLink v-if="!isEmpty" class="button" :to="link">
        <span> Mehr erfahren </span>
        <SvgIcon icon="icon--directional_arrow-right" class="is-primary-dark" />
      </RouterLink>
    </div>
    <RouterLink v-if="isEmpty" class="button is-rounded column" :to="link">
      <span> Mehr erfahren </span>
      <SvgIcon icon="icon--directional_arrow-right" class="is-primary-dark" />
    </RouterLink>
    <div v-if="imgSrc !== ''" class="column">
      <figure class="image call-to-action__Img">
        <LazyLoadedImage
          :src="imgSrc"
          alt="Placeholder image"
        ></LazyLoadedImage>
      </figure>
    </div>
  </div>
</template>

<script>
import LazyLoadedImage from "../shared/LazyLoadedImage";
import SvgIcon from "../svg/SvgIcon";

export default {
  name: "CallToAction",
  components: { LazyLoadedImage, SvgIcon },
  data() {
    return {};
  },

  props: {
    contentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isEmpty() {
      return this.imgSrc === "";
    },

    imgSrc() {
      return this.contentData.content.gallery.rows[1].columns[1].publicUrl;
    },
    title() {
      return this.contentData.content.header;
    },
    subtitle() {
      return this.contentData.content.subheader;
    },
    link() {
      return this.contentData.content.headerLink.url;
    },
  },
};
</script>

<style lang="scss">
.call-to-action {
  padding-right: 10%;
  padding-left: 10%;

  &__Img {
    position: relative;
    overflow: hidden;
    height: 100%;

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .button .icon {
    margin: 0;
    width: 3rem;
  }

  .svg-container {
    width: 3rem;
    justify-content: flex-end;
  }
}

@media only screen and (min-width: $desktop) {
  .call-to-action {
    margin: 5% 0;
  }
}
</style>